<template>
  <div class="addvolunteercon" :class="{'pc': !isPhone}">
    <pcheader v-show="!isPhone"></pcheader>
    <el-form ref="volunteer" :model="dataForm" :rules="datarules" label-position="top" style="width: 100%;">
      <div class="container">
        <div class="additem">
          <h2 class="pubtitle">志愿者服务时间</h2>
          <div class="item personul">
            <h2>9:00～12:00</h2>
            <el-form-item prop="amServiceTime">
              <el-checkbox-group v-model="dataForm.amServiceTime">
                <el-checkbox label="星期一" name="type">星期一</el-checkbox>
                <el-checkbox label="星期二" name="type">星期二</el-checkbox>
                <el-checkbox label="星期三" name="type">星期三</el-checkbox>
                <el-checkbox label="星期四" name="type">星期四</el-checkbox>
                <el-checkbox label="星期五" name="type">星期五</el-checkbox>
                <el-checkbox label="星期六" name="type">星期六</el-checkbox>
                <el-checkbox label="星期日" name="type">星期日</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <h2>14:00～16:30</h2>
            <el-form-item prop="pmServiceTime">
              <el-checkbox-group v-model="dataForm.pmServiceTime">
                <el-checkbox label="星期一" name="type">星期一</el-checkbox>
                <el-checkbox label="星期二" name="type">星期二</el-checkbox>
                <el-checkbox label="星期三" name="type">星期三</el-checkbox>
                <el-checkbox label="星期四" name="type">星期四</el-checkbox>
                <el-checkbox label="星期五" name="type">星期五</el-checkbox>
                <el-checkbox label="星期六" name="type">星期六</el-checkbox>
                <el-checkbox label="星期日" name="type">星期日</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>
        </div>
        <div class="additem">
          <h2 class="pubtitle">自愿服务岗位</h2>
          <div class="volunteerposition personul">
            <el-form-item prop="position">
              <el-radio-group v-model="dataForm.position">
                <el-radio label="讲解类" name="type">讲解类</el-radio>
                <el-radio label="非讲解类" name="type">非讲解类</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </div>
        <div class="pubbutton" @click.stop="confirmbtn" :class="{disabled: isdisabled}"><span>提交</span></div>
      </div>
    </el-form>
  </div>
</template>

<script type="text/ecmascript-6">
import Tipcommon from '@/views/common/tipcommon'
import Pcheader from '@/views/common/pcheader'
export default {
  name: 'volunteermuseum',
  components: {
    Tipcommon,
    Pcheader
  },
  data () {
    return {
      dataForm: {
        amServiceTime: [],
        pmServiceTime: [],
        position: ''
      },
      datarules: {
        amServiceTime: [{type: 'array', required: true, message: '请至少选择一段服务时间', trigger: 'change'}],
        pmServiceTime: [{type: 'array', required: true, message: '请至少选择一段服务时间', trigger: 'change'}],
        position: [{required: true, message: '请选择自愿服务岗位', trigger: 'change'}]
      },
      codeList: [],
      current: '',
      isdisabled: false,
      isPhone: false,
      screenWidth: 0
    }
  },
  created () {
  },
  mounted () {
    this.screenWidth = document.body.clientWidth
    if (this.screenWidth < 768) {
      this.isPhone = true
    } else {
      this.isPhone = false
    }
    let _this = this
    window.onresize = () => {
      _this.screenResize()
    }
  },
  methods: {
    screenResize () {
      if (document.body.clientWidth < 768) {
        this.isPhone = true
      } else {
        this.isPhone = false
      }
    },
    // 获取地址栏参数
    getQueryStringRegExp (name) {
      var reg = new RegExp('(^|\\?|&)' + name + '=([^&]*)(\\s|&|$)', 'i')
      if (reg.test(location.href)) {
        return unescape(RegExp.$2.replace(/\+/g, ' '))
      } else {
        return ''
      }
    },
    // 失焦时触发
    blurFun () {
      setTimeout(function () {
        let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
      }, 300)
    },
    open () {
      this.$confirm('请先完善志愿者基本信息, 是否完善?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({path: '/volunteerinfo', query: {museumCode: this.$cookie.get('museumCode')}})
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 确定提交
    confirmbtn () {
      this.isdisabled = true
      setTimeout(() => {
        this.isdisabled = false
      }, 2000)
      this.$refs['volunteer'].validate(valid => {
        if (valid) {
          let dataForms = Object.assign({}, this.dataForm)
          dataForms.amServiceTime = dataForms.amServiceTime.join('|')
          dataForms.pmServiceTime = dataForms.pmServiceTime.join('|')
          dataForms.museumCode = this.$cookie.get('museumCode')
          this.$http({
            url: this.$http.adornUrl(`/api/volunteer/web/volunteer/museum`),
            method: 'post',
            data: dataForms
          }).then((res) => {
            if (res) {
              if (res.data.data === '请先完善志愿者基本信息。') {
                this.open()
              } else if (res.data.data === '添加成功。') {
                this.$message({
                  message: res.data.data,
                  type: 'success'
                })
                setTimeout(() => {
                  this.$router.push({path: '/', query: {museumCode: this.$cookie.get('museumCode')}})
                }, 3000)
              } else {
                this.$message.error(res.data.data)
              }
            } else {
              this.$message.error(res.data.data)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
  *{-webkit-overflow-scrolling:touch;}
  .fl{
    float: left;
  }
  .fr{
    float: right;
  }
  .disabled{
    pointer-events: none;
    cursor: default;
    opacity: 0.6;
  }
  .addvolunteercon{
    padding: 20px;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    overflow: hidden;
    overflow-y: auto;
    .el-form-item__error{
      padding: 0;
      margin-top: -4px;
    }
    .additem{
      background: #fff;
      -webkit-border-radius: 4px;
      -moz-border-radius: 4px;
      border-radius: 4px;
      padding: 0 16px;
      margin-bottom: 20px;
      .pubtitle{
        font-size: 18px;
        height: 46px;
        line-height: 46px;
        i{
          display: inline-block;
          float: right;
          width: 8px;
          height: 15px;
          background: url("../assets/images/icon-arrow-right.png") no-repeat;
          background-size: 100% 100%;
          position: relative;
          top: 16px;
        }
      }
      .museumcode{
        .el-form-item{
          margin-bottom: 0;
          .el-radio{
            margin-bottom: 5px;
          }
        }
        &.personul{
          border-top: solid 1px #f1f1f1;
          padding: 10px 0px 10px;
        }
      }
      .volunteerposition{
        text-align: left;
        .el-form-item{
          margin-bottom: 0;
          .el-radio{
            margin-bottom: 5px;
          }
        }
        &.personul{
          border-top: solid 1px #f1f1f1;
          padding: 10px 0px 10px;
        }
        li{
          display: inline-block;
          padding: 0 10px;
          margin: 0 10px;
          height: 32px;
          line-height: 32px;
          &.on{
            border: solid 1px #a90a1a;
            -webkit-border-radius: 4px;
            -moz-border-radius: 4px;
            border-radius: 4px;
          }
        }
      }
      .item{
        &.personul{
          border-top: solid 1px #f1f1f1;
          padding: 0px 0px 30px;
        }
        .el-form-item{
          margin-bottom: 0px;
        }
        h2{
          color: #a90a1a;
          font-size: 16px;
          margin: 20px 0 15px;
        }
        .el-checkbox-group{
          line-height: 24px;
        }
        .el-checkbox{
          line-height: 24px;
          .el-checkbox__input.is-checked+.el-checkbox__label{
            color: #a90a1a!important;
          }
          .el-checkbox__input.is-checked .el-checkbox__inner{
            background-color: #a90a1a;
            border-color: #a90a1a;
          }
        }
      }
      .el-radio-group{
        width: 100%;
        .el-radio{
          display: inline-block;
          padding: 0 10px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          border: solid 1px #fff;
          -webkit-border-radius: 4px;
          -moz-border-radius: 4px;
          border-radius: 4px;
          margin-right: 10px;
          .el-radio__inner{
            display: none;
          }
          .el-radio__label{
            padding-left: 0;
          }
          &.is-checked{
            border: solid 1px #a90a1a;
            .el-radio__label{
              color: #a90a1a;
            }
          }
        }
      }
    }
    &.pc{
      padding: 0;
      .el-form{
        position: absolute;
        top: 90px;
        right: 0;
        bottom: 0;
        left: 0;
        padding: 30px 0;
        overflow: hidden;
        overflow-y: auto;
      }
      .pubbutton{
        width: 20%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/volunteermuseum.vue